// extracted by mini-css-extract-plugin
export var active = "_68-7";
export var container = "_68-0";
export var evenWidth = "_68-4";
export var large = "_68-5";
export var outlet = "_68-8";
export var slide = "_68-2";
export var small = "_68-6";
export var tab = "_68-3";
export var tabs = "_68-1";